
import {product} from "./product.js";
import {AddressForm} from '@shopify/theme-addresses';

// test

import {tns} from "tiny-slider/src/tiny-slider";

var Nav = require('bluegg-nav');

var Tabs = require('bluegg-tabs');

if (document.getElementById('product-gallery') != null) {
  tns({
    "container": "#product-gallery",
    "items": 1,
    "mouseDrag": true,
    "navContainer": "#product-thumbnails",
    "navAsThumbnails": true,
    "autoplay": false,
    "swipeAngle": false,
    "speed": 400,
    "controls": false
  });
} 

// Get your Tab elements
var alltabs = document.querySelectorAll('.js-tabs'); // Init the tabs

[].forEach.call(alltabs, function (item, i) {
  new Tabs(alltabs[i]);
});

var navToggle = document.querySelector('#nav-toggle');
var lastScrollPos = null;

function handleScrollPos() {
	if (lastScrollPos) {
		window.scroll(0, lastScrollPos);
		lastScrollPos = null;
	} else {
		lastScrollPos = window.scrollY;
	}
}

navToggle.addEventListener('click', handleScrollPos, false);

var siteNav = new Nav({
  nav: '.site-nav',
  trigger: '#nav-toggle',
  openClass: 'is-open',
  bodyClass: 'js-mobile-nav-open'
}); // Move site back to correct scroll pos when nav opens

var addressForm = document.querySelector('[data-address=root]');

if (addressForm) {
  // Fill in country and provinces
  AddressForm(addressForm, 'en');
}

if (document.getElementById('AddToCartForm') != null) {
  product();
}

document.body.classList.remove('is-tab-user');

function handleFirstTab(e) {
	if (e.keyCode === 9) { // the "I am a keyboard user" key
			document.body.classList.add('is-tab-user');
			window.removeEventListener('keydown', handleFirstTab);
	}
}

window.addEventListener('keydown', handleFirstTab);